import {
	createBrowserRouter,
	Navigate,
	RouterProvider,
} from 'react-router-dom';

import { HelmetProvider } from 'react-helmet-async';

import Home from './home/Home';
import Issues from '../../views/issues/Issues';
import Issue from '../../views/issue/Issue';
import Drafts from '../../views/drafts/Drafts';
import { AUTH_KEY } from '../../views/home/auth/Authentication.hooks';
import { Preview } from '../../components/preview/Preview';

import {
	tryRefreshToken,
	logOut,
	useRefreshOnBuild,
} from '../../templates/basic/auth/Auth.hooks';
import { useInterval } from '../../App.hooks';

import { Callback } from '../../templates/basic/callback/Callback';
import { Logout } from '../../templates/basic/auth/Logout';
import { Subscriptions } from '../../templates/basic/subscriptions/Subscriptions';
import { Success } from '../../templates/basic/subscriptions/success/Success';

import '../../App.variables.css';
import './App.css';

import config from '../../config';

function App() {
	const basename = config?.build?.subdirectory
		? config.build.subdirectory
		: undefined;
	// Remove comment to refresh build on logout
	useRefreshOnBuild();
	// const INTERVAL_TIME = 5 * 60 * 1000;
	const INTERVAL_TIME = 30 * 1000;
	useInterval(() => {
		tryRefreshToken('/', { minutes: 1 });
	}, INTERVAL_TIME);
	const onClickLogOut = localStorage.getItem(AUTH_KEY)
		? (url?: string): void => {
				console.log(`Click logout to the followin url: ${url}`);
				logOut(url || '/logout');
		  }
		: undefined;
	const routes = [
		{
			path: '/',
			element: <Home onClickLogOut={onClickLogOut} />,
		},
		{
			path: '/issues',
			element: <Issues />,
		},
		{
			path: '/issues/:id',
			element: <Issue onClickLogOut={onClickLogOut} />,
		},
		{
			path: '/issues/:id/:articleId',
			element: <Issue onClickLogOut={onClickLogOut} />,
		},
		{
			path: '/preview/:id',
			element: <Preview />,
		},
		{
			path: '/subscriptions',
			element: <Subscriptions />,
		},
		{
			path: '/subscriptions/success',
			element: <Success />,
		},
		{
			path: '/callback',
			element: <Callback />,
		},
		{
			path: '/logout',
			element: <Logout />,
		},
	];

	if (config?.app?.admin) {
		routes.push({
			path: '/drafts',
			element: <Drafts />,
		});
	}

	routes.push({
		path: '*',
		element: <Navigate to="/" replace />,
	});

	const router = createBrowserRouter(routes, {
		basename,
	});

	const classNames = ['App', 'app-magazine'];

	return (
		<HelmetProvider>
			<div className={classNames.join(' ')}>
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

export default App;
